import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var logoutRes;
export const logoutTodo = createAsyncThunk('logout', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'sign_out',

            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('token') }
        })
        return logoutRes = res

    } catch (error) {
        return logoutRes = error.response
    }
})